import React, { useRef, useState } from 'react';
import { toJpeg } from 'html-to-image';
import { MessageSquare, Share2, Loader2, PhoneCall, CheckSquare, Square, Mail, Globe } from 'lucide-react';

const DispatchConsole = ({ nominee, onWhatsApp }) => {
  const posterRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState({ text: true, poster: true });

  const handleAction = async () => {
    setLoading(true);
    try {
      // 1. GENERATE POSTER (If selected)
      let file = null;
      let dataUrl = null;
      if (options.poster) {
        dataUrl = await toJpeg(posterRef.current, { 
            quality: 0.95, 
            pixelRatio: 2, 
            cacheBust: true 
        });
        const blob = await (await fetch(dataUrl)).blob();
        file = new File([blob], `VOTE-${nominee.name.replace(/\s+/g, '-')}.jpg`, { type: 'image/jpeg' });
      }

      // 2. SMART DELIVERY LOGIC
      if (options.poster && navigator.share && navigator.canShare({ files: [file] })) {
        // MOBILE FLOW: Share image + text together
        const shareData = {
          files: [file],
          title: `Vote for ${nominee.name}`,
         // text: options.text ? `🌟 *CONGRATULATIONS ${nominee.name.toUpperCase()}!* 🌟\n\nYour nomination for the *MZINYI TALENT AWARDS 2026* has been APPROVED! 🏆\n\n🔗 *Vote Link:* https://mzinyitaitatavetaawards.netlify.app/vote/${nominee.slug}` : ""
         
        // text: `Vote for me at: https://mzinyiawards.com/vote/${nominee.slug}`,

        text: options.text ? `🌟 *CONGRATULATIONS ${nominee.name.toUpperCase()}!* 🌟\n\nYour nomination for the *MZINYI TALENT AWARDS 2026* has been APPROVED! 🏆\n\n🔗 *Vote Link:* https://mzinyiawards.com/vote/${nominee.slug}` : ""
        };
        await navigator.share(shareData);
      } else {
        // DESKTOP / FALLBACK FLOW
        if (options.poster) {
          const link = document.createElement('a');
          link.download = `VOTE-${nominee.name.toUpperCase()}.jpg`;
          link.href = dataUrl;
          link.click();
        }

        if (options.text) {
          // Small delay to ensure download starts first on desktop
          setTimeout(() => {
            onWhatsApp(nominee);
          }, 1000);
        }
        
        if (options.poster && !options.text) alert("Poster Downloaded!");
      }
    } catch (err) {
      console.error("Dispatch Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mt-8 p-6 bg-[#D4AF37]/5 border border-[#D4AF37]/20 rounded-[2rem]">
      <p className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.4em] mb-6 italic">Campaign Dispatch Console</p>

      {/* --- HIDDEN POSTER ENGINE (1080x1080) --- */}
      <div className="absolute left-[-9999px] top-0 overflow-hidden">
        <div 
          ref={posterRef}
          className="w-[1080px] h-[1080px] bg-black relative flex flex-col items-center p-16 text-white font-sans"
          style={{ 
            background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
          }}
        >
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#D4AF37]/10 blur-[150px] -z-10" />
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#D4AF37]/5 blur-[150px] -z-10" />

          {/* Header Section */}
          <div className="text-center mb-8">
             <div className="flex items-center justify-center gap-4 mb-2">
                <div className="h-1 w-20 bg-[#D4AF37]" />
                <h2 className="text-[#D4AF37] text-3xl font-black uppercase tracking-[0.8em]">Mzinyi</h2>
                <div className="h-1 w-20 bg-[#D4AF37]" />
             </div>
             <p className="text-xl font-bold tracking-[0.5em] uppercase text-white/60 mb-8">Taita Taveta Awards 2026</p>
             <p className="text-2xl font-light italic text-white/80">"Celebrating local legends in our society"</p>
          </div>

          {/* Nominee Image Box */}
          <div className="relative w-[500px] h-[500px] border-4 border-[#D4AF37] p-3 rounded-2xl mb-10 bg-black/50 shadow-[0_0_50px_rgba(212,175,55,0.2)]">
            <img 
              src={nominee.imageUrl} 
              alt="" 
              className="w-full h-full object-cover rounded-xl"
              crossOrigin="anonymous" 
            />
          </div>

          {/* Vote For Section */}
          <div className="text-center w-full">
            <p className="text-[#D4AF37] text-2xl font-black uppercase tracking-widest mb-2">Vote For</p>
            <h3 className="text-7xl font-black uppercase italic tracking-tighter mb-4 leading-none text-white">
                {nominee.name}
            </h3>
            
            {/* Category Gold Bar */}
            <div className="bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent py-3 mb-8">
                <p className="text-black text-2xl font-black uppercase tracking-[0.2em]">{nominee.category}</p>
            </div>

            {/* Voting Methods */}
            <div className="space-y-6 px-10">
                {/* Web Link Box */}
                <div className="border-2 border-white/20 p-6 rounded-2xl">
                    <p className="text-[#D4AF37] text-xl font-black uppercase tracking-[0.4em] mb-2">Voting Link</p>
                    <p className="text-3xl font-bold lowercase text-white">mzinyiawards.com/vote/{nominee.slug}</p>
                </div>

                {/* Urgency Text */}
                <p className="text-[#D4AF37] text-3xl font-black italic tracking-widest mt-6">VOTE AS MANY TIMES AS POSSIBLE</p>
            </div>
          </div>

          {/* Footer Info */}
          <div className="mt-auto w-full flex justify-between items-end border-t border-white/10 pt-8 opacity-60">
             <div className="text-left text-sm font-bold uppercase tracking-widest flex flex-col gap-1">
                <div className="flex items-center gap-2"><Mail size={14} className="text-[#D4AF37]"/> mzinyiawards@gmail.com</div>
                <div className="flex items-center gap-2"><PhoneCall size={14} className="text-[#D4AF37]"/> +254 724 562 555</div>
             </div>
             <div className="text-right">
                <p className="text-sm font-black uppercase tracking-widest">www.mzinyiawards.com</p>
             </div>
          </div>
        </div>
      </div>

      {/* --- VISIBLE CONTROLS --- */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        <button 
          onClick={() => setOptions({...options, text: !options.text})}
          className={`flex items-center gap-4 p-5 rounded-2xl border transition-all ${options.text ? 'bg-[#D4AF37]/10 border-[#D4AF37]' : 'bg-black/40 border-white/5 opacity-40'}`}
        >
          {options.text ? <CheckSquare className="text-[#D4AF37]"/> : <Square />}
          <div className="text-left">
            <p className="text-[10px] font-black uppercase tracking-widest text-white">WhatsApp Message</p>
            <p className="text-[8px] font-bold uppercase text-white/40">Include voting link & text</p>
          </div>
        </button>

        <button 
          onClick={() => setOptions({...options, poster: !options.poster})}
          className={`flex items-center gap-4 p-5 rounded-2xl border transition-all ${options.poster ? 'bg-[#D4AF37]/10 border-[#D4AF37]' : 'bg-black/40 border-white/5 opacity-40'}`}
        >
          {options.poster ? <CheckSquare className="text-[#D4AF37]"/> : <Square />}
          <div className="text-left">
            <p className="text-[10px] font-black uppercase tracking-widest text-white">Campaign Poster</p>
            <p className="text-[8px] font-bold uppercase text-white/40">Generate HQ Image</p>
          </div>
        </button>
      </div>

      <button 
        disabled={loading || (!options.text && !options.poster)}
        onClick={handleAction}
        className="w-full bg-[#D4AF37] text-black py-6 rounded-2xl font-black uppercase tracking-[0.4em] text-xs flex items-center justify-center gap-3 shadow-2xl hover:bg-white transition-all disabled:opacity-20"
      >
        {loading ? <Loader2 className="animate-spin" /> : <><Share2 size={18}/> Execute Dispatch</>}
      </button>
    </section>
  );
};

export default DispatchConsole;